export const voteStore = {
    state: {
        userVotes: [],
        projectScores: new Map(),
        voteCounts: new Map(),
        loaded: false
    },

    async loadUserVotes() {
        try {
            const response = await fetch('/api/votes/mine')
            const votes = await response.json()
            this.state.userVotes = votes
            this.state.loaded = true
        } catch (error) {
            console.error('Error loading votes:', error)
        }
    },

    async loadAllProjectScores() {
        if (this.state.projectScores.size === 0) {
            try {
                const response = await fetch('/api/projects/scores')
                const scores = await response.json()
                Object.entries(scores).forEach(([projectId, score]) => {
                    this.state.projectScores.set(parseInt(projectId), score)
                })
            } catch (error) {
                console.error('Error loading project scores:', error)
            }
        }
        return this.state.projectScores
    },

    getProjectScore(projectId) {
        return this.state.projectScores.get(projectId) || 0
    },

    async loadAllVoteCounts() {
        if (this.state.voteCounts.size === 0) {
            try {
                const response = await fetch('/api/projects/vote-counts')
                const counts = await response.json()
                Object.entries(counts).forEach(([projectId, count]) => {
                    this.state.voteCounts.set(parseInt(projectId), count)
                })
            } catch (error) {
                console.error('Error loading vote counts:', error)
            }
        }
        return this.state.voteCounts
    },

    getProjectVoteCount(projectId) {
        return this.state.voteCounts.get(projectId) || 0
    },

    getUserVotes() {
        return this.state.userVotes
    },

    getProjectScore(projectId) {
        return this.state.projectScores.get(projectId)
    },

    getVoteCount(projectId) {
        return this.state.voteCounts.get(projectId)
    },

    updateProjectScore(projectId, score) {
        this.state.projectScores.set(projectId, score)
    },

    updateVoteCount(projectId, count) {
        this.state.voteCounts.set(projectId, count)
    },

    setUserVotes(votes) {
        this.state.userVotes = votes
    }
}
